/*
 * Title:  Rewards/EarnTabContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Earn Content page content listing, click on list to expand.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { Fragment, useState, useRef } from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { calculateRedumptionTiime } from "@helpers/common";
import EarnContentItem from "./EarnContentItem";
import Successfull from "@components/Successful";
import SurveyPopUp from "@components/SurveyPopUp";
import Api from "@services/api";
import ProgramBox from "@components/ProgramBox";
import QrcodeScanner from "@components/QrcodeScanner";
import { SmsEarnItemCard } from "@components/SmsEarnItemCard";
import { useSelector } from "react-redux";
import mTouchpoints from '@model/touchpoints-model'; 

const sort = (array: any, field: any, top: any = "") => {
	array.sort(function (a, b) {
		if (a?.[field].toLowerCase() < b?.[field].toLowerCase()) { return -1; }
		if (a?.[field].toLowerCase() > b?.[field].toLowerCase()) { return 1; }
		return 0;
	});
	const required = array.filter(i => i.type == top);
	return [...required, ...array.filter(i => i.type != top)];
};

type Props = {
	authInstagram(data: any);
	onLogoutSuccess?: () => void;
	onLoginStart?: () => void;
	fetchRewards(creator_id: String);
};

const EcommerceWin: React.FC<Props | any> = (props) => {
	const popupRef = useRef(null);
	const [value, setValue] = useState(1);
	const [popup, setPopup] = useState(false);
	const [item, setItem] = useState({});
	const [loader, setLoader] = useState({});
	const surveyRef = useRef(null);
	const fan = useSelector((state:any)=>state.score.data);
	const complete = mTouchpoints.getFilterData()?.isRequiredCompleted;

	const fetchEarnRewards = () => {
		props.fetchEarnRewards(props?.data?.id);
	};

	const fetchScore = () => {
		props.fetchScore(props.programData?.program?.id, {
			fanId: props.user?.user?.data?.id,
			programId: props.programData?.program?.id,
		});
	};

	const startSurvey = (data) => {
		surveyRef?.current?.open(data);
	};
	const subscribe = async () => {
		const json = await Api.subscribeActionItemEvent(props?.data?.id);
		fetchEarnRewards();
		fetchScore();
	};

	const fetchRewardAfterFollow = () => {
		const timer = setTimeout(() => {
			fetchEarnRewards();
			fetchScore();
		}, 60000);
		return () => clearTimeout(timer);
	};

	const followRecheck = (data) => {
		const timer = setTimeout(() => {
			Api.followCheck(data.creatorId, data.type, data.touchpointId);
			fetchRewardAfterFollow();
		}, 15000);
		return () => clearTimeout(timer);
	};

	const updateTouchpoints = (data) => {
		data["creatorId"] = props?.data?.id;
		props.updateTouchpoints(data);
		followRecheck(data);
	};

	const openCamera = () => {
		popupRef?.current?.open();
	}

	const closeCamera = () => {
		popupRef?.current?.close();
	}

	const authorize = async (data) => {
		return await Api.authorizeActionItem(data);
	}


	let actions = [];
	let touchpoints = sort(props.touchpoints || [], 'name', 'required');
	let isDisabled = false;
	let priorityId = null;

	if(touchpoints.filter(i=>i.type=="required").length>0){
		(touchpoints.filter(i=>i.type=="required")?.[0]?.actions || []).map((item)=>{
			if(item?.config?.priority>0 && !item?.config?.hide && item?.shares?.fanEngagement==0 && priorityId == null){
				isDisabled = true;
				priorityId = item?.id
			} else if(item?.shares?.fanEngagement==0 && priorityId == null){
				priorityId = item?.id
			}
		})
	}

	touchpoints.filter(i => i.active && i.actions.filter(i => i.config?.active).length > 0).map((item) => {
		const action = (item.actions.filter(i => i.action == "connect")?.[0] || {});
		let redeemed = [];
		let notRedeemed = [];
		item.actions.map((i) => {
			if (i?.config?.active) {
				let datum = i;
				datum = {
					...datum,
					isDisabled:item?.type=="required"?priorityId==datum?.id?false:datum?.shares?.fanEngagement>0?false:true:isDisabled,
					touchpoint: {
						name: item.name,
						type: item.type,
						id: item.id,
						url: item?.url,
					}
				}
				if (action?.config?.limit != action?.shares?.fanEngagement) {
					datum = {
						...datum,
						socialAction: action
					}
				}
				const config = calculateRedumptionTiime(datum?.config, datum?.shares?.lastEngagement, datum?.shares?.fanEngagement, datum?.totalEngagements, -1);
				if (config?.isCardHide) {
				} else if (config?.isDisabled) {
					redeemed.push(datum);
				} else {

					redeemed.push(datum);
				}


			}
		});
		let sorted = sort(redeemed, "title");
		let shareIndex = redeemed?.findIndex((reedeem) => reedeem?.action === "connect");
		if (shareIndex !== -1) {
			let shareDel = sorted.splice(shareIndex, 1);
			sorted.unshift(shareDel[0])
		}
		actions.push(...sorted);
	});

	let used = 0;
	actions?.map((reward) => {
		if (reward?.shares?.fanEngagement !== 0) {
			used++;
		}
	})

	return (
		<>
			<div
			>

				{/* Loader  */}
				{props.isFetching && <div className="flex items-center justify-center">
					<svg width={38} height={38} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke={'#fff'}>
						<g fill="none" fillRule="evenodd">
							<g transform="translate(1 1)" strokeWidth="2">
								<circle strokeOpacity=".5" cx="18" cy="18" r="18" />
								<path d="M36 18c0-9.94-8.06-18-18-18">
									<animateTransform
										attributeName="transform"
										type="rotate"
										from="0 18 18"
										to="360 18 18"
										dur="1s"
										repeatCount="indefinite"
									/>
								</path>
							</g>
						</g>
					</svg>
				</div>}
				{used > 0 && <p className="font-[300] text-[13px] tracking-[0.07em] leading-[17px] body-inlay-primary py-[17px] uppercase">Complete</p>}
				<div className="space-y-[5px]">
					{actions?.map((reward, index2) => {
						if (reward?.shares?.fanEngagement !== 0) {
						if (reward.action === "sms") {
							return <SmsEarnItemCard fetchEarnRewards={fetchEarnRewards} item={reward} value={fan.phoneNumber || fan.extraInfo?.phoneNumber} disabledInput={(fan?.phoneNumber || fan?.extraInfo?.phoneNumber || "").length>9} />
						}
						return (
							<EarnContentItem
								item={reward}
								redemptionInfo={reward.shares}
								touchpoint={item}
								redeemed={reward?.shares?.pointsEarned > 0}
								key={index2}
								user={props.user}
								data={props.data}
								fetchEarnRewards={fetchEarnRewards}
								fetchScore={fetchScore}
								startSurvey={startSurvey}
								subscribe={subscribe}
								updateTouchpoints={updateTouchpoints}
								username={props.data?.username}
								loader={loader}
								openCamera={openCamera}
								closeCamera={closeCamera}
								authorize={authorize}
								isDisabled={isDisabled}
							/>
						);
					}
					})}
				</div>
				<p className="font-[300] text-[13px] tracking-[0.07em] leading-[17px] body-inlay-primary py-[17px] uppercase">
					{used < actions?.length && (complete ? "add more": "available")}
				</p>
				<div className="space-y-[5px]">
					{actions?.map((reward, index2) => {
						if (reward?.shares?.fanEngagement === 0) {
						if (reward.action === "sms") {
							return <SmsEarnItemCard fetchEarnRewards={fetchEarnRewards} item={reward} value={fan.phoneNumber || fan.extraInfo?.phoneNumber} disabledInput={(fan?.phoneNumber || fan?.extraInfo?.phoneNumber || "").length>9} />
						}
						return (
							<EarnContentItem
								item={reward}
								redemptionInfo={reward.shares}
								touchpoint={item}
								redeemed={reward?.shares?.pointsEarned > 0}
								key={index2}
								user={props.user}
								data={props.data}
								fetchEarnRewards={fetchEarnRewards}
								fetchScore={fetchScore}
								startSurvey={startSurvey}
								subscribe={subscribe}
								updateTouchpoints={updateTouchpoints}
								username={props.data?.username}
								loader={loader}
								openCamera={openCamera}
								closeCamera={closeCamera}
								authorize={authorize}
								isDisabled={isDisabled}
							/>
						);
					}
					})}
				</div>
				<QrcodeScanner ref={popupRef} />
				{popup && <Successfull {...item} tile="tile" />}
				<SurveyPopUp ref={surveyRef} />
			</div>
		</>
	);
};

const mapStateToProps = ({ user, EarnReward, creator, RedeemReward }) => {
	return {
		instagram: user.instagram,
		discord: user.discord,
		touchpoints: EarnReward.data,
		isFetching: EarnReward.isFetching,
		shopify: user.shopify,
		user: user.user,
		programData: user.programData,
		data: creator.program,
		program: creator.program,
		isRegistrationEnd: creator?.isRegistrationEnd,
		rewards: RedeemReward.data,
	};
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
	const { dispatch } = dispatchProps;
	const { actions } = require("@redux/UserRedux");
	const { rewardActions } = require("@redux/EarnRewardRedux");
	const { actions: scoreAction } = require("@redux/ScoreRedux");
	return {
		...stateProps,
		authInstagram: (data) => {
			dispatch(actions.authInstagram(data));
		},
		authDiscord: (data) => {
			dispatch(actions.authDiscord(data));
		},
		authShopify: (data) => {
			dispatch(actions.authShopify(data));
		},
		fetchEarnRewards: (creator_id) => {
			rewardActions.fetchEarnRewards(dispatch, creator_id);
		},
		fetchScore: (programId) => {
			scoreAction.fetchScores(dispatch, programId);
		},
		updateTouchpoints: (data) => {
			rewardActions.updateTouchpoints(dispatch, data);
		},
	};
};

export default connect(mapStateToProps, undefined, mergeProps)(EcommerceWin);
